"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Automation',
  data() {
    return {
      settings: {
        welcomeActive: true,
        welcomeMsg: '¡Hola! Gracias por suscribirte a mi contenido exclusivo. 💖 ¿Qué te gustaría ver hoy?',
        aiActive: false,
        aiMode: 'friendly',
        aiPrompt: '',
        scheduleActive: true,
        spamActive: true
      }
    };
  }
};